import _ from 'lodash'

import { defaultOptions } from '../../utils'
import { AvatarPieceBase } from '../Base'
import { Style as AvatarMouthStyle1 } from './Style1'
import { Style as AvatarMouthStyle2 } from './Style2'
import { Style as AvatarMouthStyle3 } from './Style3'

export const NAME = 'mouth'
export const STYLES = {
  style1: AvatarMouthStyle1,
  style2: AvatarMouthStyle2,
  style3: AvatarMouthStyle3
}
export const INLINE_STYLE = {
  width: '220%',
  height: 'auto',
  left: '50%',
  top: 0,
  position: 'absolute',
  pointerEvents: 'none',
  transform: 'translateX(-50%) translateY(-5%)'
}
export const AvatarMouth = ({ style, color: colorSlug, ...rest }) => {
  const colorOptions = _.get(defaultOptions, `${NAME}.colors`, [])
  const color = _.find(colorOptions, { slug: colorSlug }) || colorOptions[0]
  const colors = color.colors

  return (
    <AvatarPieceBase
      name={NAME}
      STYLES={STYLES}
      style={style}
      colors={colors}
      inlineStyle={INLINE_STYLE}
      {...rest}
    />
  )
}
